// extracted by mini-css-extract-plugin
module.exports = {"negative_spacingBottom":"Yy1rK"};